module.exports = __webpack_public_path__ + "static/media/facebooklogo.657493b3.svg";